//#region src/dom/listen.ts
/** @internal */
function listen(target, type, listener, options) {
	target.addEventListener(type, listener, options);
	return () => target.removeEventListener(type, listener, options);
}
//#endregion
export { listen };

//# sourceMappingURL=listen.js.map